import React from "react";

export default function AsideImage({
  src,
  alt,
  aspect = "aspect-[4/3]",
  credit,
  className = "",
  testId = "aside-image",
}) {
  return (
    <div className={className}>
      <figure className={`relative overflow-hidden rounded-lg ${aspect} bg-brand-paper`} data-testid={testId}>
        <img
          src={src}
          alt={alt}
          loading="lazy"
          decoding="async"
          className="absolute inset-0 h-full w-full object-cover"
        />
      </figure>
      {credit && (
        <div className="mt-2 text-[11.5px] text-brand-ink/45 tracking-wide" data-testid={`${testId}-credit`}>
          {credit}
        </div>
      )}
    </div>
  );
}
